import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({ providedIn: 'root' })
export class PostService {
  private apiUrl = `${API_BASE_URL}/posts`;

  constructor(private http: HttpClient) {}

  createPost(payload: FormData): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }

  getPosts(tenantId: number): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { params: { tenant_id: tenantId } });
  }

  getPublicDocuments(tenantId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/public-documents`, {
      params: { tenant_id: tenantId }
    });
  }

  getDashboardPosts(tenantId: number): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, {
      params: {
        tenant_id: tenantId,
        include_all: true
      }
    });
  }

  likePost(postId: number, userId: number, tenantId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${postId}/like`, { user_id: userId, tenant_id: tenantId });
  }

  unlikePost(postId: number, userId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${postId}/like`, { params: { user_id: userId } });
  }

  getPostLikes(postId: number, userId: number): Observable<{ count: number; liked: boolean }> {
    return this.http.get<{ count: number; liked: boolean }>(`${this.apiUrl}/${postId}/likes`, {
      params: { user_id: userId }
    });
  }

  getBirthdayLikeStatus(
    tenantId: number,
    birthdayUserId: number,
    userId: number,
    birthdayDate: string
  ): Observable<{ count: number; liked: boolean }> {
    const params = new HttpParams()
      .set('tenant_id', String(tenantId))
      .set('birthday_user_id', String(birthdayUserId))
      .set('user_id', String(userId))
      .set('birthday_date', birthdayDate);
    return this.http.get<{ count: number; liked: boolean }>(`${this.apiUrl}/birthday-likes`, { params });
  }

  likeBirthdayPost(
    tenantId: number,
    birthdayUserId: number,
    userId: number,
    birthdayDate: string
  ): Observable<{ count: number; liked: boolean }> {
    return this.http.post<{ count: number; liked: boolean }>(`${this.apiUrl}/birthday-likes`, {
      tenant_id: tenantId,
      birthday_user_id: birthdayUserId,
      user_id: userId,
      birthday_date: birthdayDate
    });
  }

  unlikeBirthdayPost(
    tenantId: number,
    birthdayUserId: number,
    userId: number,
    birthdayDate: string
  ): Observable<{ count: number; liked: boolean }> {
    const params = new HttpParams()
      .set('tenant_id', String(tenantId))
      .set('birthday_user_id', String(birthdayUserId))
      .set('user_id', String(userId))
      .set('birthday_date', birthdayDate);
    return this.http.delete<{ count: number; liked: boolean }>(`${this.apiUrl}/birthday-likes`, { params });
  }

  getComments(postId: number, offset = 0, limit = 3): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${postId}/comments`, {
      params: { offset, limit }
    });
  }

  addComment(postId: number, payload: { user_id: number; tenant_id: number; comment_text: string; parent_comment_id?: number }): Observable<any> {
    return this.http.post(`${this.apiUrl}/${postId}/comments`, payload);
  }

  updatePost(postId: number, payload: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${postId}`, payload);
  }

  deletePost(postId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${postId}`);
  }

  getPostById(postId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${postId}`);
  }
}
